export enum Environments {
  development = "development",
  staging = "staging",
  production = "production",
}
